import { render, staticRenderFns } from "./modificaContatti.vue?vue&type=template&id=5d077230"
import script from "./modificaContatti.vue?vue&type=script&lang=js"
export * from "./modificaContatti.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports